// extracted by mini-css-extract-plugin
export default {"button":"ContactFormRequestContent_button__WcxXV","menuControl":"ContactFormRequestContent_menuControl__ylqW-","tabLabel":"ContactFormRequestContent_tabLabel__fzcWV"};